import styles from './styles.module.scss';
const { checkbox, checkbox_label, header } = styles;

type optionsType = {
  label: string;
  value?: string;
};

type Props = {
  label: string;
  inputName?: string;
  options: optionsType[];
  register: ReturnType<typeof import('react-hook-form').useForm>['register'];
  required?: boolean;
};

const RadioButton = ({ label, inputName, options, register, required = false }: Props) => {
  return (
    <div>
      {label && <span className={header}>{label}</span>}
      {options.map((option, idx) => (
        <label key={idx} className={checkbox_label}>
          <input
            className={checkbox}
            type="radio"
            value={option.value ?? option.label}
            name={inputName || label}
            required={required}
            {...register(inputName || label)}
          />
          {option.label}
        </label>
      ))}
    </div>
  );
};

export default RadioButton;
